import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Login.module.css';
import { useLang } from '../i18n/LanguageContext';
import { forgotPasswordText } from '../i18n/pages/forgotPassword';

const BookIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { lang } = useLang();
  const t = forgotPasswordText[lang];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || 'Request failed');
      }
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginContainer}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}><BookIcon /></div>
          <span className={styles.logoText}>Guestbook<span>.cz</span></span>
        </div>

        <div className={styles.title}>{t.title}</div>
        <div className={styles.subtitle}>
          {submitted ? t.subtitleSent : t.subtitleDefault}
        </div>

        {submitted ? (
          <>
            <p style={{ textAlign: 'center', color: '#334155', fontSize: '0.9rem', lineHeight: 1.6, margin: '8px 0 24px' }}>
              {t.sentBody(email)}
            </p>
            <div className={styles.footer}>
              <Link to="/login">{t.backToLogin}</Link>
            </div>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <label className={styles.label}>{t.emailLabel}</label>
                <input
                  className={styles.input}
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder={t.emailPlaceholder}
                  required
                  autoFocus
                />
              </div>
              <button className={styles.button} type="submit" disabled={loading}>
                {loading ? t.submittingBtn : t.submitBtn}
              </button>
            </form>

            {error && <div className={styles.error}>{error}</div>}

            <div className={styles.footer}>
              <Link to="/login">{t.backToLogin}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
